import { localeErrorStatusMessageType } from '../en-US'

/* eslint-disable quotes */
export const errorStatusMessage: localeErrorStatusMessageType = {
  defaultMessage: 'Algo salió mal',
  tryAgain: 'Inténtalo De Nuevo',
  already_exists: 'El usuario con el nombre de usuario proporcionado ya existe',
  permission_denied: 'No tienes permisos',
  not_authenticated: 'No estás autorizado',
  transaction_limit: 'La transferencia está fuera de límites',
  transaction_limit_does_not_exist: 'Los límites para las transacciones no existen',
  400: 'Solicitud incorrecta',
  password_validation_error: 'La longitud de la contraseña debe ser superior a 4',

  invalidUserNameOrPassword: 'Nombre de usuario o contraseña incorrectos',
  referral_code_not_found: 'Código de referencia no encontrado',
  referral_code_already_activated: 'Código de referencia ya activado',

  referral_site_name_blank: 'Este campo puede no estar en blanco',
  referral_site_link_blank: 'Este campo puede no estar en blanco',
  referral_site_link_invalid: 'Ingrese una URL válida',
  not_enough_money: 'No hay suficiente dinero',
  email_not_verified: 'Por favor confirme su correo electrónico',
  documents_not_approved: 'Por favor confirme sus documentos',
  balance_not_low_enough: 'Saldo real demasiado alto para intercambiar',
  insufficient_funds_on_bonus_balance: 'No hay fondos suficientes en el saldo de bonos',

  coefs_changed: 'Se cambiaron los corefs .',
  error_block_bet_data: 'Algunas tarifas están bloqueadas ahora',
  error_exist_bet: 'Alguna tarifa no existe',
  user_is_banned: 'Esta cuenta está prohibida',
  payment_system_limits: 'La cantidad no cumple con los límites',
  incorrect_old_password: 'Contraseña antigua incorrecta',
  access_and_refresh_token_invalid: 'Tu sesión ha expirado. Por favor, inicie sesión de nuevo',
}
